import { useContext } from "react";
import EventFormContext from "./EventFormContext";

const useEventFormContext = () => {
	return useContext(EventFormContext);
};

export default useEventFormContext;
